import React, {Component, PropTypes} from 'react'
import {Icon} from 'antd'
import Animate from 'rc-animate'

class ImagePreview extends React.Component {
	static defaultProps = {
    visible: false
  }
	constructor(props) {
		super(props)
		const {visible, previewUrl} = this.props
		this.state = {
			previewUrl: previewUrl,
			modalVisible: visible,
			closed: true
		}
	}
	closeHandle = (e) => {
		e.stopPropagation()
		this.setState({modalVisible: false})
		const onClose = this.props.onClose()
		onClose && onClose()
	}
	componentWillReceiveProps (nextProps) {
		// if (this.shouldComponentUpdate(nextProps)) {
		// 	this.setState({previewUrl: nextProps.previewUrl, modalVisible: nextProps.visible})
		// }
		this.setState({previewUrl: nextProps.previewUrl, modalVisible: nextProps.visible})
	}
	// shouldComponentUpdate(nextProps, nextState) {
  //   if (this.props.visible || this.props.visible !== nextProps.visible) {
  //     return true
  //   }
  //   if (nextState) {
  //     if (nextState.modalVisible !== this.state.modalVisible || nextState.previewUrl !== this.state.previewUrl) {
  //       return true
  //     }
  //   }
  //   return false
	// }
	animationEnd = () => {
		const {modalVisible} = this.state
    this.setState({closed: !modalVisible})
	}
	render() {
		const {closed} = this.state
		return (
			<Animate
				component=""
				showProp='data-show'
				onEnd={this.animationEnd}
				transitionName="preview-zoom">
					
					<div data-show={this.state.modalVisible} style={{display: !closed ? 'block' : 'none'}} className="image-preview-w" onClick={this.closeHandle}>
						<div className="image-preview-mask">
							<div className="image-preview">
								<div className="image-preview-close-icon" onClick={this.closeHandle}><Icon type="close"/></div>
								<img src={this.state.previewUrl} alt="" className="image-preview-img"/>
							</div>
						</div>
						
					</div>
			</Animate>
		)
	}
}

export default ImagePreview


// WEBPACK FOOTER //
// ./src/components/common/ImagePreview/index.js